import styled from 'styled-components';

export const OptionalStepContainer = styled.div`
  margin-bottom: var(--spacing-medium);
  padding: var(--spacing-medium);
  background: #FFFFFF;
  border: var(--border-width) solid var(--color-neutral-light-darker);
  border-radius: var(--border-radius-primary);
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const OptionalStepIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--color-neutral-light-darker);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;

  &::before {
    content: '!';
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
`;

export const OptionalStepContent = styled.div`
  flex: 1;
  font: var(--font-paragraph);
  color: var(--color-neutral-dark-darker);
  text-align: left;
  line-height: 1.4;
`;

export const OptionalStepMessage = styled.span`
  font: var(--font-paragraph);
  color: var(--color-text);
`;

export const SkipStepButton = styled.button`
  background: none;
  border: none;
  color: var(--color-highlight);
  font: var(--font-paragraph);
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  transition: opacity 0.2s ease;
  display: inline;

  &:hover {
    opacity: 0.8;
  }
`;
